<script setup lang="ts">
/** CaStat — angka ringkas (jumlah berkas, ukuran, sisa kuota). Angka selalu tabular. */
defineProps<{ nilai: string; label: string; ikon?: string }>()
</script>

<template>
  <div class="rounded-control border border-line bg-surface-2 p-3.5">
    <div class="flex items-center gap-2 text-muted">
      <UIcon v-if="ikon" :name="ikon" class="size-4 shrink-0" />
      <p class="ca-caption font-medium truncate">{{ label }}</p>
    </div>
    <p class="ca-num mt-1.5 text-xl font-extrabold text-ink leading-none">{{ nilai }}</p>
  </div>
</template>
